import { CalibrationCalculationDto, CalibrationDistributionPreviewDto, CalibrationPeriodDto } from './models';
import { LinqService, QueryOptions } from 'linquest';

import { IAjaxProvider } from 'jinqu';

export class CalibrationPeriodApi extends LinqService {

  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  getAsync(id?: string, options?: QueryOptions) {
    const url = `/CalibrationPeriod/GetAsync`;
    let query = this.createQuery<CalibrationPeriodDto>(url);
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};
    options.params.push({ key: 'Id', value: id && id.toString() });
    query = query.withOptions(options);
    return query.firstAsync();
  }

  saveAsync(dto?: CalibrationPeriodDto, options?: QueryOptions) {
    const url = `/CalibrationPeriod/SaveAsync`;
    let query = this.createQuery<any>(url);
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};
    options.data = dto;
    query = query.withOptions(options);
    return query.firstAsync();
  }

  listTranslated(options?: QueryOptions) {
    const url = `/CalibrationPeriod/ListTranslated`;
    let query = this.createQuery<CalibrationPeriodDto>(url);
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};
    query = query.withOptions(options);
    return query;
  }

  calculate(calibrationPeriodId?: string, options?: QueryOptions) {
    const url = `/CalibrationPeriod/Calculate`;
    let query = this.createQuery<CalibrationCalculationDto>(url);
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};
    options.data = calibrationPeriodId;
    query = query.withOptions(options);
    return query.firstAsync();
  }

  getActiveCalculation(calibrationPeriodId?: string, options?: QueryOptions) {
    const url = `/CalibrationPeriod/GetActiveCalculation`;
    let query = this.createQuery<CalibrationCalculationDto>(url);
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};
    options.params.push({ key: 'calibrationPeriodId', value: calibrationPeriodId && calibrationPeriodId.toString() });
    query = query.withOptions(options);
    return query.firstAsync();
  }

  getDistributionPreview(calibrationPeriodId?: string, options?: QueryOptions) {
    const url = `/CalibrationPeriod/GetDistributionPreview`;
    let query = this.createQuery<CalibrationDistributionPreviewDto>(url);
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};
    options.params.push({ key: 'calibrationPeriodId', value: calibrationPeriodId && calibrationPeriodId.toString() });
    query = query.withOptions(options);
    return query.firstAsync();
  }
}
